import { useState, useEffect } from 'react';
import { Flex, TextStyled } from '../../component-library';
import { PatientFacialDetection } from '../../components';
import { useTestContext } from '../../context/testContext';
import { useReceiveMessage } from '../../context/messageContext';

const ContrastSensitivity = () => {
  const { testData, setMultipleTestFieldValues } = useTestContext();
  const [currentLogmarContent, setCurrentLogmarContent] = useState('');
  const [currentLogmarSize, setCurrentLogmarSize] = useState('');
  const [currentFontColor, setCurrentFontColor] = useState('black');
  const [logmarData, setLogmarData] = useState({});
  const messageFromOptician = useReceiveMessage();

  const hasContentChanged = (newLogmarContent, newLogmarSize, newFontColor) => {
    return newLogmarContent !== currentLogmarContent || newLogmarSize !== currentLogmarSize || newFontColor !== currentFontColor;
  };

  useEffect(() => {
    if (hasContentChanged(logmarData.characters, logmarData.size, logmarData.fontColor)) {
      setCurrentLogmarSize(logmarData.size);
      setCurrentLogmarContent(logmarData.characters);
      setCurrentFontColor(logmarData.fontColor);
    }
  }, [logmarData]);

  useEffect(() => {
    switch (messageFromOptician.type) {
      case 'contrastSensitivity':
        setLogmarData({
          size: messageFromOptician.content.fontSize,
          distance: messageFromOptician.content.distanceFromScreen,
          backgroundColor: messageFromOptician.content.backgroundColor,
          fontColor: messageFromOptician.content.fontColor,
          characters: messageFromOptician.content.characters,
        });
        break;
      case 'updateContrastSensitivityContent':
        let currentLogmarData = logmarData;
        currentLogmarData['backgroundColor'] = messageFromOptician.content.backgroundColor;
        currentLogmarData['fontColor'] = messageFromOptician.content.fontColor;
        currentLogmarData['characters'] = messageFromOptician.content.characters;
        setMultipleTestFieldValues(currentLogmarData);
        setLogmarData({
          ...logmarData,
          backgroundColor: messageFromOptician.content.backgroundColor,
          fontColor: messageFromOptician.content.fontColor,
          characters: messageFromOptician.content.characters,
        });
        break;
      case 'resizeLogmar':
        setLogmarData({
          size: messageFromOptician.content.fontSize,
          distance: messageFromOptician.content.distanceReferenceInMM,
          characters: messageFromOptician.content.logmarCharacters,
          fontColor: messageFromOptician.content.fontColor,
        });
        break;
      default:
        break;
    }
  }, [messageFromOptician]);

  return (
    <Flex>
      <PatientFacialDetection testMode={testData.testMode} />
      <Flex bg='#fff' width='100vw' alignItems='center' height='100vh' justifyContent='center' style={{ zIndex: '9' }}>
        <TextStyled color={currentFontColor} fontFamily='OpticianSans' fontSize={`${currentLogmarSize}px`}>
          {currentLogmarContent}
        </TextStyled>
      </Flex>
    </Flex>
  );
};

export default ContrastSensitivity;
